import { ReactChild } from 'react';
import QuestionMarkTooltip from '../../QuestionMarkTooltip';

export interface StatCardProps {
  title: string;
  stat: number | string | JSX.Element;
  icon?: ReactChild;
  toolTip?: string;
}

export default function StatCard(props: StatCardProps) {
  const { title, stat, icon, toolTip } = props;

  return (
    <>
      <div className='bg-white rounded-md flex flex-row p-4 relative h-full'>
        <div className='flex-grow flex flex-col justify-between gap-2 font-bold'>
          <div className='flex gap-3'>
            <span className='text-md'>{title}</span>
            <div>{toolTip && <QuestionMarkTooltip toolTip={toolTip} />}</div>
          </div>
          <span className='text-primaryColor-normal text-xl w-full '>
            {stat}
          </span>
        </div>
        {icon && <div className='p-1'>{icon}</div>}
      </div>
    </>
  );
}
